import { render, staticRenderFns } from "./ImageFileInput.vue?vue&type=template&id=1ab95d31&scoped=true&"
import script from "./ImageFileInput.vue?vue&type=script&setup=true&lang=js&"
export * from "./ImageFileInput.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ImageFileInput.vue?vue&type=style&index=0&id=1ab95d31&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab95d31",
  null
  
)

export default component.exports